<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="collector-publications"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      :actions="tableActions"
      :sessions="sessions"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { DELETE } from '@/helpers/enums/table-actions'
import { rootMapper } from '@/store/modules/root'
import { CollectorPublicationsApi } from '@/api/resources/Collector/CollectorPublicationsApi'
import { PublicationModel as Model } from './Model'
import { TABLE_ACTIONS } from './table-headers'
import { COLLECTOR_PUBLICATIONS_ROUTES as ROUTES } from './utils'
import {
  collectorPublicationsStoreModule as StoreModule,
  collectorPublicationsMapper as StoreMapper,
} from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/PublicationsFilter.vue'

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewCollectorPublicationsList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    ...rootMapper.mapGetters(['profile']),
    ...StoreMapper.mapState(['sessions']),
    tableActions() {
      return this.profile?.is_superuser
        ? [...TABLE_ACTIONS, DELETE]
        : TABLE_ACTIONS
    },
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  methods: {
    getDeleteProps(data) {
      const model = new Model(data)

      return {
        titleText: model.modal_delete.delete,
        successText: model.response_success.delete,
        errorText: model.response_error.delete,
        mainText: void 0,
        action: () => new CollectorPublicationsApi().deleteEmpty(data.publication_id),
      }
    },
  },
}
</script>
